{"schemaVersion":1,"release":{"version":"1.0.7","build":155,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.0.7-155.dmg","sha256":"3aa6f56176d8cacb9c491e9f1d66086d44ad731b95d57f29afc2fa19d64b78a3","size":28972234}}
